// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__2eCPn","list":"PatternAutocomplete_list__352V3"};